// Store functionality
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  companies: [],
  companyInfo: {},
  allCompaniesList: [],
  companiesCount: null,
  companiesNextPage: false,
  companyWall: [],
};

// Create a new store
const store = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default store;
